/**
 * @jsx jsx
 */
import { css, jsx } from '@compiled/react';

import { type CustomItemComponentProps } from '@atlaskit/menu';
import { token } from '@atlaskit/tokens';

export const RenameMenuItemComponent = ({ children, ...props }: CustomItemComponentProps) => (
	<div css={tabRenamingStyles}>
		<div {...props}>{children}</div>
	</div>
);

const tabRenamingStyles = css({
	outlineOffset: token('space.negative.025'),
	outline: `${token('border.width.focused')} solid ${token('color.border.focused')}`,
});
